import VirtualStagingIcon from "../../assets/icon/virtualstagingicon.png";
import VirtualTourIcon from "../../assets/icon/virtualtouricon.svg";
import VirtualRenovationIcon from "../../assets/icon/virtualtouricon.svg";
import VirtualPlanIcon from "../../assets/icon/floor-plan-icon.svg";
import ThreeDRenderIcon from "../../assets/icon/3drendericon.svg";
import UnBeateableIcon from "../../assets/icon/unbeatable-price.svg";
import TurnAroundIcon from "../../assets/icon/fast-turnaround.svg";
import SubscriptionIcon from "../../assets/icon/no-subscription.svg";
import supportIcon from "../../assets/icon/support.svg";
import MoneyIcon from "../../assets/icon/money-back.svg";
import FreeTrialIcon from "../../assets/icon/free-trial.svg";
import BrandValueIcon from "../../assets/icon/brand-value.svg";
import GrowlineIcon from "../../assets/icon/grow-bottom-line.svg";
import OrderingUx from "../../assets/icon/ordering-ux.svg";
import DeliveryIcon from "../../assets/icon/free-delivery.svg";
import CustomerIcon from "../../assets/icon/customer.svg";
import marketingIcon from "../../assets/icon/marketing.svg";
import RealTimeIcon from "../../assets/icon/real-time.svg";
import ApprovalIcon from "../../assets/icon/approval.svg";
import CommentingIcon from "../../assets/icon/commenting.svg";
import AvatarImg from "../../assets/images/avatar.svg";
import SellPropertyImg from "../../assets/icon/sell-properties.svg";
import HigherSalesIcon from "../../assets/icon/higher-sales.svg";
import BetterListingIcon from "../../assets/icon/better-listing.svg";
import CostEffectiveIcon from "../../assets/icon/cost-effective.svg";
import CompetitiveEdgeIcon from "../../assets/icon/competitive-edge.svg";
import DesignOptionIcon from "../../assets/icon/design-option.svg";
import AfterOne from "../../assets/images/1.png";
import AfterTwo from "../../assets/images/2.png";
import AfterThree from "../../assets/images/3.png";
import AfterFour from "../../assets/images/4.png";
import AfterFive from "../../assets/images/5.png";
import AfterSix from "../../assets/images/6.png";

// ServicesContent array
export const whyChooseUs = [
    {
        title: "Unbeatable prices",
        detail: "We want to help your listing marketing shine, while helping you stay on budget.",
        image: UnBeateableIcon,
    },
    {
        title: "Fast turnarounds Fast turnarounds",
        detail: "Time is of the essence when you are marketing a home. We’ll get your images back to you within 24-48 hours, tops. Need your images faster? We can make that happen, too.",
        image: TurnAroundIcon,
    },
    {
        title: "No subscriptions",
        detail: "You can bring any project to us, any time, any size. No monthly commitment needed!",
        image: SubscriptionIcon,
    },
    {
        title: "24x7 support",
        detail: "Customer service experts available 24/7 on live chat, phone or email.",
        image: supportIcon,
    },
    {
        title: "Money back guarantee",
        detail: "If you aren’t happy with the way your images turned out, let us know, and we will refund your money.",
        image: MoneyIcon,
    },
    {
        title: "Free trial for first image",
        detail: "Your first image is on us! Try us out at no cost and see what we can do for you.",
        image: FreeTrialIcon,
    },
];
// how its work array
export const HowItsWork = [
    {
        title: "Choose a Style",
        detail: "Select a design style or service type that fits your property goals.",
    },
    {
        title: "Upload photos",
        detail: "Submit clear images or floor plans—we handle the rest.",
    },
    {
        title: "Get them delivered",
        detail: "Receive beautifully enhanced visuals within 1–3 business days.",
    },
];
//   partners
export const Partners = [
    {
        title: "Build your brand's value",
        image: BrandValueIcon,
    },
    {
        title: "Grow your bottom-line",
        image: GrowlineIcon,
    },
    {
        title: "Best-in-class ordering UX",
        image: OrderingUx,
    },
    {
        title: "Hassle free delivery",
        image: DeliveryIcon,
    },
    {
        title: "Delight your customers",
        image: CustomerIcon,
    },
    {
        title: "Free marketing content",
        image: marketingIcon,
    },
];

// collaborate project
export const CollaborateProject = [
    {
        title: "Real-Time Collaboration",
        image: RealTimeIcon,
        detail: "Real estate agents, homeowners, and interior designers can collaborate on staging projects simultaneously, making instant updates and seeing changes as they happen."
    },
    {
        title: "Commenting & Suggestions",
        image: CommentingIcon,
        detail: "Easily add comments, suggest changes, and provide feedback directly within the staging platform, streamlining communication and decision-making."
    },
    {
        title: "Approval Workflows",
        image: ApprovalIcon,
        detail: "Simplify the approval process with built-in workflows that notify all stakeholders when changes are made and need to be reviewed."
    },
];

// testimonial data
export const TestimonialData = [
    {
        title: "It proved to be exactly the kind of home we wanted.",
        src: AvatarImg,
        detail: "We wish to express our thanks for your hard work in finding us a temporary home, which proved to be exactly what we wanted.",
        clientName: "Jaydon Aminoff",
        designation: "Landlord"
    },
    {
        title: "It proved to be exactly the kind of home we wanted.",
        src: AvatarImg,
        detail: "We wish to express our thanks for your hard work in finding us a temporary home, which proved to be exactly what we wanted.",
        clientName: "Jaydon Aminoff",
        designation: "Landlord"
    },
    {
        title: "It proved to be exactly the kind of home we wanted.",
        src: AvatarImg,
        detail: "We wish to express our thanks for your hard work in finding us a temporary home, which proved to be exactly what we wanted.",
        clientName: "Jaydon Aminoff",
        designation: "Landlord"
    },
    {
        title: "It proved to be exactly the kind of home we wanted.",
        src: AvatarImg,
        detail: "We wish to express our thanks for your hard work in finding us a temporary home, which proved to be exactly what we wanted.",
        clientName: "Jaydon Aminoff",
        designation: "Landlord"
    },
];

// benefits of virtual staging property
export const BenefitsOfVirtual = [
    {
        title: "Sell Properties Faster",
        detail: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
        image: SellPropertyImg,
    },
    {
        title: "Get a Higher Sales Price",
        detail: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
        image: HigherSalesIcon,
    },
    {
        title: "Better Listing Appeal",
        detail: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
        image: BetterListingIcon,
    },
    {
        title: "Cost Effective",
        detail: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
        image: CostEffectiveIcon,
    },
    {
        title: "Get a Competitive Edge",
        detail: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
        image: CompetitiveEdgeIcon,
    },
    {
        title: "Variety of Design Options",
        detail: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
        image: DesignOptionIcon,
    },
];

// similar srvice content
export const SimilarContentData = [
    {
        AfterImg: AfterTwo,
        BeforeImg: AfterOne,
        title: "360  Virtual Tour",
        detail: "Unlock your property's potential with stunning interactive tours.",
    },
    {
        AfterImg: AfterFour,
        BeforeImg: AfterThree,
        title: "Virtual Renovation",
        detail: "Transform outdated spaces with realistic remodeling simulations.",
    },
    {
        AfterImg: AfterSix,
        BeforeImg: AfterFive,
        title: "Virtual Staging",
        detail: "Add stylish furnishings to empty rooms to boost buyer interest.",
    },
]